export default {"src":"/_next/static/media/SharedWithMeActive.66b7c3bb.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};